import { ApiTags, rootApi } from '../../rootApi';

export interface IContact {
    id: string,
    title: string,
}
export interface ContactDetails {
    oDataContext: string;
    oDataEtag: string;
    contactId: string
    programId: string
    semesterId: string
    year: string
    firstName: string
    lastName: string
    middleName: string
    fullName: string
    batch: string
    academicSession: string
    rollNumber: string
    email: string
    extensionRequired: boolean
}

const TAG = ApiTags.Contact;
const getTags = (entities: IContact[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]
const getTags1 = (entities: ContactDetails[]) => [
    ...entities.map((p) => ({ type: TAG, id: p.contactId })),
    TAG,
];

const contactsApi = rootApi.injectEndpoints({
    overrideExisting: false,
    endpoints: builder => ({
        getContacts: builder.query<IContact[], void>({
            query: () => `/Contacts`,
            providesTags: (result) => result ? getTags(result) : [TAG]
        }),

        getContactDetails: builder.query<ContactDetails, { contactId: string }>({
            query: ({ contactId }) => `Contacts/(${contactId})`,
            providesTags: (result) => (result ? getTags1([result]) : [TAG]),
        }),
    })
})

export const {
    useGetContactsQuery,
    useLazyGetContactDetailsQuery,
    useGetContactDetailsQuery
} = contactsApi;